<template>
  <div class="flex relative inline-block">
    <button
      @click.prevent="opened = !opened"
      :class="`flex items-center focus:outline-none mr-3 ${buttonClasses}`">

      <span
        class="hidden md:inline-block"
        v-text="title">
      </span>

      <fa v-if="showCaret" icon="caret-down" class="ml-3"/>
    </button>

    <div
      :class="{invisible: opened === false}"
      class="bg-white nunito rounded shadow-md mt-2 absolute mt-8 top-0 w-56 overflow-auto z-30">

      <ul class="list-reset">
        <slot/>
      </ul>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    buttonClasses: {
      type: String,
      required: false,
      default: '',
    },
    showCaret: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      opened: false
    }
  },

  methods: {
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.opened = false;
      }
    },

    closeManually() {
      this.opened = false;
    }
  },

  mounted() {
    document.addEventListener('click', this.close);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.close);
  }
}
</script>
